import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NavBar.css';

import enFlag from '../../assets/svg/enFlag.svg';
import esFlag from '../../assets/svg/esFlag.svg';

const languages = [
    { code: 'en', name: 'EN', flag: enFlag },
    { code: 'es', name: 'ES', flag: esFlag },
];

function NavBar() {
    const { t, i18n } = useTranslation(); // Hook para traducciones
    const [language, setLanguage] = useState(i18n.language || 'en'); // Estado del idioma
    const [activeComponent, setActiveComponent] = useState('');
    const location = useLocation();

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
        i18n.changeLanguage(lang); // Cambia el idioma de i18next
    };

    useEffect(() => {
        // Actualizar activeComponent según la ruta actual
        const path = location.pathname;
        if (path.startsWith('/dashboard') || path.startsWith('/login') || path.startsWith('/principal-form')) setActiveComponent('dashboard');
        else if (path.startsWith('/plans')) setActiveComponent('plans');
        else if (path.startsWith('/faq')) setActiveComponent('faq');
        else if (path.startsWith('/contact')) setActiveComponent('contact');
        else setActiveComponent('home'); // Ruta por defecto
    }, [location]);

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    const isMobile = windowSize.width <= 1000;

    return (
        <div className="navbar navbar-expand-xl shadow">
            <div className="container-fluid">
                {/* <div className="d-flex d-xl-none me-2">
                    <button type="button" className="navbar-toggler sidebar-mobile-main-toggle rounded-pill">
                        <i className="ph-list"></i>
                    </button>
                </div> */}

                <div className="navbar-brand flex-1">
                    <Link to="/" className="d-inline-flex align-items-center">
                        <img className='top-logo' src="../../../assets/images/RevEat_Logo_PNG.png" alt="" />
                        {/* <h2 className='logo-text'>RevEat</h2> */}
                    </Link>
                </div>

                {isMobile ? (
                    <div className="d-flex w-100 w-xl-auto scrollbar-hidden border-top border-top-xl-0 order-1 order-xl-0 pt-2 pt-xl-0 mt-2 mt-xl-0 flex-column">
                        <div className="nav gap-1 justify-content-center flex-wrap flex-xl-wrap mx-auto row w-9">
                            <div className="nav-item col-3 d-flex justify-content-center ms-1 me-1">
                                <Link to="/" className={`navbar-nav-link rounded ${activeComponent === 'home' ? 'active' : ''}`} onClick={() => setActiveComponent('home')}>
                                    <i className="ph-house me-2"></i>
                                    {t('home')}
                                </Link>
                            </div>
                            <div className="nav-item col-3 d-flex justify-content-center ms-1 me-1">
                                <Link to="/dashboard" className={`navbar-nav-link rounded dashboardItem ${activeComponent === 'dashboard' ? 'active' : ''}`} onClick={() => setActiveComponent('dashboard')}>
                                    <i className="ph-chart-bar me-2"></i>
                                    {t('dashboard')}
                                </Link>
                            </div>
                            <div className="nav-item col-3 d-flex justify-content-center ms-1 me-1">
                                <Link to="/plans" className={`navbar-nav-link rounded ${activeComponent === 'plans' ? 'active' : ''}`} onClick={() => setActiveComponent('plans')}>
                                    <i className="ph-credit-card me-2"></i>
                                    {t('plans')}
                                </Link>
                            </div>
                            <div className="nav-item col-3 d-flex justify-content-center ms-1 me-1">
                                <Link to="/faq" className={`navbar-nav-link rounded ${activeComponent === 'faq' ? 'active' : ''}`} onClick={() => setActiveComponent('faq')}>
                                    <i className="ph-question me-2"></i>
                                    {t('help')}
                                </Link>
                            </div>
                            <div className="nav-item col-3 d-flex justify-content-center ms-1 me-1">
                                <Link to="/contact" className={`navbar-nav-link rounded ${activeComponent === 'contact' ? 'active' : ''}`} onClick={() => setActiveComponent('contact')}>
                                    <i className="ph-cardholder me-2"></i>
                                    {t('contact.title')}
                                </Link>
                            </div>
                            <div className="nav-item dropdown languageButton col-3 d-flex justify-content-center ms-1 me-1">
                                <a href="#" className="navbar-nav-link dropdown-toggle" id="languageDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {/* Mostrar la bandera y el nombre del idioma seleccionado */}
                                    <img src={languages.find(l => l.code === language).flag} alt={language} style={{ width: '20px', marginRight: '8px' }} />
                                    {languages.find(l => l.code === language).name}
                                </a>
                                <ul className="dropdown-menu" aria-labelledby="languageDropdown">
                                    {languages
                                        .filter(l => l.code !== language) // Filtrar el idioma seleccionado
                                        .map((lang) => (
                                            <li key={lang.code}>
                                                <a href="#" className="dropdown-item" onClick={() => handleLanguageChange(lang.code)}>
                                                    <img src={lang.flag} alt={lang.name} style={{ width: '20px', marginRight: '8px' }} />
                                                    {lang.name}
                                                </a>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="d-flex w-100 w-xl-auto overflow-auto overflow-xl-visible scrollbar-hidden border-top border-top-xl-0 order-1 order-xl-0 pt-2 pt-xl-0 mt-2 mt-xl-0 itemsWrapper justify-content-center align-items-center">
                        <div className="nav-item">
                            <Link to="/" className={`navbar-nav-link rounded ${activeComponent === 'home' ? 'active' : ''}`} onClick={() => setActiveComponent('home')}>
                                <i className="ph-house me-2"></i>
                                {t('home')}
                            </Link>
                        </div>
                        <div className="nav-item">
                            <Link to="/dashboard" className={`navbar-nav-link rounded ${activeComponent === 'dashboard' ? 'active' : ''}`} onClick={() => setActiveComponent('dashboard')}>
                                <i className="ph-chart-bar me-2"></i>
                                {t('dashboard')}
                            </Link>
                        </div>
                        <div className="nav-item">
                            <Link to="/plans" className={`navbar-nav-link rounded ${activeComponent === 'plans' ? 'active' : ''}`} onClick={() => setActiveComponent('plans')}>
                                <i className="ph-credit-card me-2"></i>
                                {t('plans')}
                            </Link>
                        </div>
                        <div className="nav-item">
                            <Link to="/faq" className={`navbar-nav-link rounded ${activeComponent === 'faq' ? 'active' : ''}`} onClick={() => setActiveComponent('faq')}>
                                <i className="ph-question me-2"></i>
                                {t('help')}
                            </Link>
                        </div>
                        <div className="nav-item">
                            <Link to="/contact" className={`navbar-nav-link rounded ${activeComponent === 'contact' ? 'active' : ''}`} onClick={() => setActiveComponent('contact')}>
                                <i className="ph-cardholder me-2"></i>
                                {t('contact.title')}
                            </Link>
                        </div>
                        <div className='nav-item'>
                            <div className="nav-item dropdown languageButton">
                                <a href="#" className="navbar-nav-link dropdown-toggle" id="languageDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {/* Mostrar la bandera y el nombre del idioma seleccionado */}
                                    <img src={languages.find(l => l.code === language).flag} alt={language} style={{ width: '20px', marginRight: '8px' }} />
                                    {languages.find(l => l.code === language).name}
                                </a>
                                <ul className="dropdown-menu" aria-labelledby="languageDropdown">
                                    {languages
                                        .filter(l => l.code !== language) // Filtrar el idioma seleccionado
                                        .map((lang) => (
                                            <li key={lang.code}>
                                                <a href="#" className="dropdown-item" onClick={() => handleLanguageChange(lang.code)}>
                                                    <img src={lang.flag} alt={lang.name} style={{ width: '20px', marginRight: '8px' }} />
                                                    {lang.name}
                                                </a>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default NavBar;
